import React from 'react';
import styles from './DataProviderSelector.module.scss';

export default function LegacyServiceProviderPlaceholder(props) {
  const { dataProvider: { logo, name } } = props;
  return (
    <div>
      <div>Legacy Placeholder</div>
      <img alt={name} className={styles.logo} src={logo} width="80" />
      <div>This will eventually be replaced with the legacy banking provider iFrame.</div>
      <div>
        You would have been shown the legacy screen scraping&nbsp;
        { name }
        &nbsp;login form.
      </div>
    </div>
  );
}
